
import { getFirestore, collection, query, where, getDocs, limit } from "firebase/firestore";
import { ZamziApp } from "@/types/zamziApp";
import { getApp } from "firebase/app";

const mapDocToZamziApp = (doc: any): ZamziApp => {
    const data = doc.data();
    return {
      ...data,
      id: doc.id,
      isInMaintenance: data.isInMaintenance ?? false,
    };
};

export const getZamziApp = async (appId: string): Promise<ZamziApp | null> => {
    const firebaseApp = getApp();
    const db = getFirestore(firebaseApp);
    if (!appId) {
        console.error("[Client Firestore] App ID is required to get Zamzi app.");
        return null;
    }

    const appsCollectionRef = collection(db, "zamziApps");
    const q = query(appsCollectionRef, where("appId", "==", appId), limit(1));
    const querySnapshot = await getDocs(q);

    if (!querySnapshot.empty) {
        const appSnap = querySnapshot.docs[0];
        console.log(`[Client Firestore] Zamzi app document with appId ${appId} found.`);
        return mapDocToZamziApp(appSnap);
    } else {
        console.log(`[Client Firestore] Zamzi app document with appId ${appId} not found.`);
        return null;
    }
};
